import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref, watch, onBeforeMount, onMounted } from 'vue';
import Table from '~/components/Collections/Table.vue';
import { ITableHeader } from '~/config/table/headers';
import Badge from '~/components/UIComponents/Badge.vue';
import RarityIcon from '~/components/Collections/RarityIcon.vue';
import ImgOverlayCard from '~/components/Collections/ImgOverlayCard.vue';
import { usePageRoute, ERoute } from '~/composables/usePageRoute';
import { formatChainSymbol } from '~/utils/format';
import { UserItem } from '~/types/user-items';
import FilmTokenIcon from '../Token/FilmTokenIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemsTable',
  props: {
    rows: { default: () => [] },
    isLoading: { type: Boolean, default: false },
    tableHeaders: { default: () => [] },
    header: { default: '' },
    onRowClick: null
  },
  emits: [],
  setup(__props: any, { emit }) {

const props = __props as { rows: any[], isLoading: boolean, tableHeaders: ITableHeader[], header: string, onRowClick?: (item: UserItem) => void };



const { route, store, i18n } = useContext();
const { goTo } = usePageRoute();

return { __sfc: true,emit, props, route, store, i18n, goTo, Table, Badge, RarityIcon, ImgOverlayCard, ERoute, formatChainSymbol, FilmTokenIcon }
}

})